module.exports = {
  localeName: 'hr-HR',
  momentFormat: 'DD.MM.YYYY'
};
